import React, { FC } from 'react'
import i18n from 'i18next'
import { IChipProps } from '../Bill'

const Chip: FC<IChipProps> = ({ onClick }) => {
  return (
    <div className='method' onClick={onClick}>
      <img className='icon' src={require('@img/payment/wechat-pay.png')} />
      <div className='dropdown'>
        <div className='name'>{i18n.t('pay.wechatPay')}</div>
      </div>
    </div>
  )
}

export default Chip
